export default __webpack_public_path__ + "media/images/react_icons/file-upload-e5dac491a5765efe5488ef87d70e5b82.svg";